import { render, staticRenderFns } from "./PpeApply.vue?vue&type=template&id=427c20ab&scoped=true&"
import script from "./PpeApply.vue?vue&type=script&lang=js&"
export * from "./PpeApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c20ab",
  null
  
)

export default component.exports